import axios from 'axios';

const API_BASE = '/api/lri';
const config = require('../config/dev.json');

export const getProjectData = async id => {

    const origin = window.location.origin;
    const referer = document.referrer;
    if (id !== undefined && id !== "") {
        try {
            return await axios.get(
                `${config.base_URL}${API_BASE}/project/${id}`,
                {
                    headers: {
                        "user_id": localStorage.getItem("user"),
                        "Origin_URL": origin,
                        "Referer_URL": referer,
                    },
                    "Access-Control-Allow-Headers": "*",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "*"
                }
            );
        } catch (error) {
            console.error("getProjectData failed:", error);
            throw error;
        }
    }
};